import React, { useState } from "react";
import { toast } from "sonner";
import { Database, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const LABELS = {
    appointment_types: "Types de RDV",
    pharmacists: "Pharmaciens",
    availability_rules: "Horaires",
    availability_exceptions: "Absences",
    appointments: "Rendez-vous",
    contact_messages: "Messages",
};

export default function DataTab() {
    const [form, setForm] = useState({ target_url: "", target_db: "lalutrive" });
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState(null);

    const run = async () => {
        setBusy(true);
        setResult(null);
        try {
            const r = await api.post("/admin/database/copy", form);
            setResult(r.data.copied);
            toast.success("Copie terminée");
        } catch (e) {
            const d = e?.response?.data?.detail;
            toast.error(typeof d === "string" ? d : "Échec de la copie");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-2xl bg-white border border-brand-line p-8" data-testid="data-tab">
            <div className="flex items-center gap-3 mb-4">
                <Database className="h-5 w-5 text-brand-primary" />
                <h2 className="font-display text-2xl text-brand-ink">Copier les données vers une autre base</h2>
            </div>
            <p className="font-sans text-sm text-brand-ink/65 mb-6">
                Copie tous les rendez-vous, messages, pharmaciens, horaires et types de RDV vers la base indiquée
                (par exemple chez Infomaniak). Rien n'est supprimé ici ; vous pouvez relancer la copie autant de fois que nécessaire.
            </p>
            <label className="ll-eyebrow text-brand-ink/60 block mb-2">Adresse de connexion MongoDB</label>
            <input type="password" autoComplete="off" value={form.target_url} onChange={(e) => setForm({ ...form, target_url: e.target.value })}
                placeholder="mongodb://utilisateur:motdepasse@hote:27017/?authSource=admin"
                className="w-full border-b border-brand-ink/30 focus:border-brand-primary outline-none py-2 font-sans mb-5" data-testid="data-target-url-input" />
            <label className="ll-eyebrow text-brand-ink/60 block mb-2">Nom de la base</label>
            <input value={form.target_db} onChange={(e) => setForm({ ...form, target_db: e.target.value })}
                className="w-full border-b border-brand-ink/30 focus:border-brand-primary outline-none py-2 font-sans mb-6" data-testid="data-target-db-input" />
            <button onClick={run} disabled={busy || !form.target_url} className="ll-btn ll-btn-primary disabled:opacity-60" data-testid="data-copy-btn">
                {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Copie en cours…</> : "Copier les données"}
            </button>
            {result && (
                <ul className="mt-6 font-sans text-sm divide-y divide-brand-line" data-testid="data-copy-result">
                    {Object.entries(result).map(([k, n]) => (
                        <li key={k} className="flex justify-between py-2"><span>{LABELS[k] || k}</span><span>{n}</span></li>
                    ))}
                </ul>
            )}
        </div>
    );
}
